var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.596 37.405a1.938 1.938 0 002.797 0l13.5-14.143a1.921 1.921 0 00-.065-2.724 1.928 1.928 0 00-2.724.065L21.923 31.258V3.928c0-1.068-.86-1.928-1.929-1.928-1.068 0-1.928.86-1.928 1.929v27.329L7.893 20.595a1.928 1.928 0 00-2.724-.065 1.928 1.928 0 00-.065 2.724l13.5 14.143-.008.008z"
  })));
}
export default SvgArrowDown;